// eslint-disable-next-line
export const SET_PLAYABLE = 'BACKEND_PLAYABLE_SET_PLAYABLE'



// WEBPACK FOOTER //
// ./src/features/Backend/data/playable/constants.js